export const GROUPS_OF_DAYS = {
    ALL_DAYS: 'ALL_DAYS',
    MONDAYS_TO_FRIDAYS: 'MONDAYS_TO_FRIDAYS',
    SATURDAYS_TO_SUNDAYS: 'SATURDAYS_TO_SUNDAYS',
};
